/**
 * 生成海口销售单打印页面
 * orderData：订单数据
 * titleConfig：标题配置
 * nameConfig：打印业务员配置
 * footnoteConfig：脚注配置
 * capitalAmount：订单大写总金额
 * showDisc：是否显示优惠
 */
function buildHKSalesPrintHtml(orderData, titleConfig, nameConfig, footnoteConfig, capitalAmount, showDisc) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row tableConten">
            <div class="div-table-cell" style="width: 4%">${index + 1}</div>
            <div class="div-table-cell" style="width: 16%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 18%">${AP.AutoSerise}</div>
            <div class="div-table-cell" style="width: 10%">${AP.Size}</div>
            <div class="div-table-cell" style="width: 8%">${AP.Origin}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell fdzt" style="width: 6%">${AP.Count}</div>
            <div class="div-table-cell fdzt" style="width: 10%">${AP.BillingPrice}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${(AP.Count * AP.BillingPrice).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 13%">${AP.GoodsLocation}</div>
            </div>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div  class="print-title">${titleConfig && titleConfig.RValue ? titleConfig.RValue : '销售单'}</div>
                        </div>
                        <div class="print-orderDetail">
                            <div class="row">
                                <div class="col col-7" style="height:auto;padding-right: 0px;padding-left: 0px;margin-left:10px;">
                                    <label class="label_l">客户名称：</label>
                                    <div class="grid-content cname">${orderData.EntpCusName}</div>
                                </div>
                                <div class="col col-5">
                                    <label class="label_r">发货：</label>
                                    <div class="grid-content">${orderData.ShipTypeName}</div>
                                </div>
                                <div class="col col-6">
                                    <label class="label_r w60">物流：</label>
                                    <div class="grid-content">${orderData.LogisticName}</div>
                                </div>
                                <div class="col col-6 barfa">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-7">
                                    <label class="label_l">客户电话：</label>
                                    <div class="grid-content">${orderData.PhoneNum}</div>
                                </div>
                                <div class="col col-5">
                                    <label class="label_r">是否欠款：</label>
                                    <div class="grid-content debts">${orderData.IsDebts ? '**' : ''}</div>
                                </div>
                                <div class="col col-6">
                                    <label class="label_r w60">日期：</label>
                                    <div class="grid-content">${orderData.CreateTime}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-7">
                                    <label class="label_l">客户类型：</label>
                                    <div class="grid-content">${orderData.CusType}</div>
                                </div>
                                <div class="col col-5">
                                    <label class="label_r">部门：</label>
                                    <div class="grid-content">${orderData.OrgName}</div>
                                </div>
                                <div class="col col-6">
                                    <label class="label_r w60">支付：</label>
                                    <div class="grid-content">${orderData.PayTypeName}</div>
                                </div>
                            </div>
                            <div class="row ${orderData.IsModified ? 'MAnchor' : ''}">
                                ${orderData.IsModified ? `<div class="isModif">改</div>` : ''}                           
                               <div class="col rkCol">
                                <label class="label_r">出库备注：</label>
                                <div class="grid-content">${orderData.Remark}</div>
                            </div>
                       </div>                            
                    </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 4%">序</div>
                                <div class="div-table-cell" style="width: 16%">编码</div>
                                <div class="div-table-cell" style="width: 16%">名称</div>
                                <div class="div-table-cell" style="width: 18%">车型</div>
                                <div class="div-table-cell" style="width: 10%">规格</div>
                                <div class="div-table-cell" style="width: 8%">产地</div>
                                <div class="div-table-cell" style="width: 6%">单位</div>
                                <div class="div-table-cell" style="width: 6%">数量</div>
                                <div class="div-table-cell" style="width: 10%">单价</div>
                                <div class="div-table-cell" style="width: 12%">金额</div>
                                <div class="div-table-cell" style="width: 13%">仓位</div>
                            </div>
                            ${tableConten}
                        </div>
                        <div class="order-remark btd">
                            <div style="width:57.33333%;">人民币大写：${capitalAmount}</div>
                            <div style="width:16.66667%;">${orderData.ShipAmount > 0 ? '运费：' + orderData.ShipAmount : ''}</div>
                            <div style="width:16.66667%;">数量：${orderData.TotalCount}</div>
                            <div style="width:26.66667%;text-align: right;">金额：${orderData.SurplusMoney}</div>
                            <div style="width:16.66667%;">${showDisc && orderData.DiscountAmount > 0 ? '优惠：' + orderData.DiscountAmount : ''}</div>
                        </div>
                        <div class="order-remark">${footnoteConfig && footnoteConfig.RValue ? footnoteConfig.RValue.replace(/\n/g, '<br/>') : ''}</div>

                        <div class="order-remark fwb">
                            <div style="width:16.66667%;">开单人：${nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName}</div>
                            <div style="width:16.66667%;">点货：</div>
                            <div style="width:16.66667%;">验货：</div>
                            <div style="width:16.66667%;">送货：</div>
                        </div>
                        </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售单打印</title>

        <style type="text/css">
            .print-title-view {
                width: 790px;
                position: relative;
                justify-content: space-between;
                align-items: flex-end;
                padding: 0;
                padding-top:67px;
            }
            .print-title-view .order-code {
                display: none;
            }
            .order-detail {
                color: #000;
                padding-right: 30px;
            }
            .order-remark {
                width: 762px;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding-top: 3px;
                color: #000;
            }
            .print-title {
                margin: 0 auto;
                text-align: center;
                font-size: 24px;
                font-weight: bold;
                color: #000;
                min-height: 26px;
                padding-bottom: 5px;
            }
            .print-zone {
                width: 200mm;
            }
            .print-table-main {
                width: 762px;
                font-size: 14px;
            }
            .print-table-main .div-table-cell {
                overflow: hidden;
                word-break: break-all;
                word-wrap: break-word;
                height: auto;
                line-height: 25px;
                padding-left: 1px;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                border-bottom: 1px solid #000;
                color: #000;
            }
            .print-table-main .tableConten .div-table-cell {
                line-height: 14px;
                display: -webkit-box;
                -webkit-box-orient: horizontal;
                -webkit-box-align: center;
                /*box不兼容是用下面*/
                display: flex;
                align-items: center;     
                padding-bottom: 5px;
                padding-top: 5px;                        
            }
            .print-table-main .div-table-row {
                display: flex;
                border-left: 1px solid #000;
            }
            .fdzt {
                font-size: 14px;
            }
            .fwb {
                font-weight: bold;
            }
            .btd {
                border-bottom: 1px dashed #000;
                font-weight: bold;
            }
            .print-orderDetail {
                width: 762px;
                margin-bottom: 10px;
                font-size: 14px;
                color: #000;
                padding: 0;
                padding-left: 5px;
                margin-right: 20px;
            }
            .print-orderDetail .barfa {
                display: none;
            }
            .print-orderDetail .row {
                margin-left: -10px;
                margin-right: -10px;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                margin-bottom: 2px;
            }
            .print-orderDetail .row::after,
            .print-orderDetail .row::before {
                display: table;
                content: '';
                clear: both;
            }
            .print-orderDetail .row .col {
                float: left;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding-left: 10px;
                padding-right: 10px;
                line-height: 18px;
                height: 18px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .print-orderDetail .col-5 {
                width: 20.83333%;
            }
            .print-orderDetail .col-6 {
                width: 25%;
            }
            .print-orderDetail .col-7 {
                width: 29.16667%;
            }
            .print-orderDetail .qrcode-canvas,
            .print-orderDetail .qrcode-image {
                width: 40px;
                height: 40px;
                display: inline-block;
                vertical-align: top;
            }

            .print-orderDetail .row .height40 {
                height: 40px !important;
            }

            .print-orderDetail .row .col .label_l {
                width: 70px;
                text-align: left;
                vertical-align: middle;
                float: left;
                line-height: 18px;
            }
            .print-orderDetail .row .col .label_r {
                width: 70px;
                text-align: right;
                vertical-align: middle;
                float: left;
                line-height: 18px;
            }
            .w60{width:60px !important;}
            .print-orderDetail .row .col .grid-content {
                display: inline-block;
                min-height: 18px;
                border-radius: unset;
                line-height: 18px;
            }
            .print-orderDetail .row .col .debts {
                padding-top: 3px;
            }
            .print-orderDetail .row .col .grid-content::after,
            .print-orderDetail .row .col .grid-content::before {
                display: table;
                content: '';
                clear: both;
            }
            .print-orderDetail .rkCol{
                height: auto !important;
            }
            .print-orderDetail .rkCol .grid-content{
                overflow: hidden !important;
                word-break: break-all !important;
                word-wrap: break-word !important;
                white-space: break-spaces !important;
                white-space: pre-wrap !important;
                width: 70% !important;
            } 
            .MAnchor{
                position: relative;
                padding-bottom: 10px;
            }
            .isModif {
                text-align: center;
                border-radius: 50%;
                -webkit-border-radius: 50%;
                -ms-border-radius: 50%;
                -o-border-radius: 50%;
                -moz-border-radius: 50%;
                padding: 3px 11px;
                color: red;
                /*border: solid 2px red;*/
                position: absolute;
                right: 80px;
                bottom: -5px;
                display: none;
            }
            .cname {
                overflow: hidden !important;
                word-break: break-all !important;
                word-wrap: break-word !important;
                white-space: pre-wrap !important;
                white-space: break-spaces !important;
                width: 70%;
            }                           
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成崇峰销售单打印页面
 * orderData：订单数据
 * titleConfig：标题配置
 * nameConfig：打印业务员配置
 * footnoteConfig：脚注配置
 * capitalAmount：订单大写总金额
 */
function buildCFSalesPrintHtml(orderData, titleConfig, nameConfig, footnoteConfig, capitalAmount) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell fdzt" style="width: 6%">${index + 1}</div>
            <div class="div-table-cell" style="width: 10%">${(AP.GoodCode || '').split(',')[0]}</div>
            <div class="div-table-cell" style="width: 18%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 16%">${AP.AutoSerise}</div>
            <div class="div-table-cell fdzt" style="width: 8%">${AP.Count + AP.Unit}</div>
            <div class="div-table-cell fdzt" style="width: 8%">${AP.Price}</div>
            <div class="div-table-cell fdzt" style="width: 10%">${(AP.Count * AP.Price).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${AP.GoodsLocation}</div>    
            </div>         
            `;
        });
    }
    let printContent = `
    <div class="print-for">
    <div class="print-title-view">
        <div class="order-code"></div>
        <div class="print-title">${titleConfig.RValue}</div>
        <div class="order-detail">
            <div class="right">单号：${orderData.OrderCode}</div>
            <div class="right">
                日期：
                <span>${orderData.CreateTime}</span>
            </div>
        </div>
    </div>
    <div class="lodop-table-main">
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户名称</div>
            <div class="div-table-cell fdzt" style="width: 80%">${orderData.EntpCusName}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">序号</div>
            <div class="div-table-cell" style="width: 10%">UNP码</div>
            <div class="div-table-cell" style="width: 18%">汽配编码</div>
            <div class="div-table-cell" style="width: 16%">配件名称</div>
            <div class="div-table-cell" style="width: 16%">车型</div>
            <div class="div-table-cell" style="width: 8%">出库数</div>
            <div class="div-table-cell" style="width: 8%">售价</div>
            <div class="div-table-cell" style="width: 10%">金额</div>
            <div class="div-table-cell" style="width: 12%">仓位</div>
        </div>
        ${tableConten}
        <div class="div-table-row-bottom">
            <div class="b-txt">合计：</div>
            <div class="b-allnum">${orderData.TotalCount}</div>
            <div class="b-allprice">￥${orderData.GoodsAmount}</div>
        </div>
    </div>
    <div class="order-remark">
        <div style="width:25%;">${orderData.ShipAmount > 0 ? '运费：' + orderData.ShipAmount : ''}</div>
        <div style="width:25%;">${
            orderData.DiscountType == 0
                ? '优惠：无'
                : orderData.DiscountType == 1
                ? '优惠金额：-' + orderData.DiscountAmount
                : orderData.DiscountType == 2
                ? '整单优惠：-' + orderData.DiscountRate + '%'
                : ''
        }</div>
        <div style="width:25%;">实收金额：￥${(orderData.GoodsAmount - orderData.DiscountAmount).toFixed(2)}</div>
        <div style="width:25%;"></div>
    </div>
    <div class="order-remark">
        <div style="width:50%;">备注：${orderData.Remark}</div>
        <div style="width:50%;" class="order-money">人民币大写：${capitalAmount}</div>
    </div>
    <div class="order-remark">
        <div style="width:25%;">支付方式：${orderData.PayTypeName}</div>
        <div style="width:25%;">发货方式：${orderData.ShipTypeName == '物流' ? orderData.LogisticName : orderData.ShipTypeName}</div>
        <div style="width:25%;">
            业务员：${nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName}
        </div>
        <div style="width:25%;" class="order-picking">备货员：</div>
    </div>
    <div class="order-remark">${footnoteConfig.RValue}</div>
</div>
                    `;

    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 12px 0;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }

        .order-detail {
            color: #000;
        }

        .lodop-print-zone {
            width: 200mm;
        }

        .lodop-table-main {
            width: 762px;
            font-size: 12px;
        }

        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding-top: 5px;
            margin-bottom: 0;
            color: #000;
            box-sizing: border-box;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 50%;
            margin: 0 auto;
            text-align: center;
            font-size: 22px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
        }
        .div-table-cell {
            white-space: nowrap;
            overflow: hidden !important;
            text-overflow: clip;
            height: auto;
            line-height: 26px;
            padding-left: 1px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            color: #000;
            font-size: 12px;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }
        .div-table-row-bottom {
            color: #000;
            line-height: 26px;
            border: 1px solid #000;
            display: flex;
            justify-content: flex-end;
            text-align: center;
        }
        .b-txt {
            width: 15%;
        }
        .b-allnum {
            width: 6%;
        }
        .b-allprice {
            width: 28%;
        }
        .pall-count {
            text-align: right;
        }
        .fdzt {
            font-size: 14px;
        }
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成灏域销售单打印页面
 * orderData：订单数据
 * titleConfig：标题配置
 * nameConfig：打印业务员配置
 * footnoteConfig：脚注配置
 * amountConfig：启动打印总计金额大写配置
 * capitalAmount：订单大写总金额
 */
function buildHYSalesPrintHtml(orderData, titleConfig, nameConfig, footnoteConfig, amountConfig, capitalAmount) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">${index + 1}</div>
            <div class="div-table-cell" style="width: 18%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
            <div class="div-table-cell fdzt" style="width: 6%">${AP.Count}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell" style="width: 8%">${AP.Price}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${(AP.Count * AP.Price).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 13%">${AP.GoodsLocation}</div>   
            </div>          
            `;
        });
    }
    let printContent = `
    <div class="print-for">
    <div class="print-title-view">
        <div class="order-code"></div>
        <div class="print-title">${titleConfig.RValue}</div>
        <div class="order-detail">
            <div class="right">单号：${orderData.OrderCode}</div>
            <div class="right">
                日期：
                <span>${orderData.CreateTime}</span>
            </div>
        </div>
    </div>
    <div class="print-table-main">
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户名称</div>
            <div class="div-table-cell fdzt" style="width: 80%">${orderData.EntpCusName}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户地址</div>
            <div class="div-table-cell" style="width: 80%">${orderData.FullAddress}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">序号</div>
            <div class="div-table-cell" style="width: 18%">汽配编码</div>
            <div class="div-table-cell" style="width: 16%">配件名称</div>
            <div class="div-table-cell" style="width: 20%">车型</div>
            <div class="div-table-cell" style="width: 6%">数量</div>
            <div class="div-table-cell" style="width: 6%">单位</div>
            <div class="div-table-cell" style="width: 8%">售价</div>
            <div class="div-table-cell" style="width: 12%">销售总价</div>
            <div class="div-table-cell" style="width: 13%">仓位</div>
        </div>
        ${tableConten}
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell" style="width: 18%"></div>
            <div class="div-table-cell" style="width: 16%"></div>
            <div class="div-table-cell pall-count" style="width: 20%">总数量 &nbsp;</div>
            <div class="div-table-cell" style="width: 6%">${orderData.TotalCount}</div>
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell pall-count" style="width: 8%">总价 &nbsp;</div>
            <div class="div-table-cell" style="width: 12%">${(orderData.GoodsAmount + orderData.ShipAmount).toFixed(2)}</div>
            <div class="div-table-cell" style="width: 13%"></div>
        </div>
    </div>

    </div>
    <div class="order-remark">
        <div style="width:16.66667%;">运费：${orderData.ShipAmount}</div>
        <div style="width:25%;">支付方式：${orderData.PayTypeName}</div>
        <div style="width:25%;">发货方式：${orderData.ShipTypeName}</div>
        <div style="width:16.66667%;">业务员：${nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName}</div>
        <div style="width:16.66667%;">备货员：</div>
    </div>
    ${
        orderData.DiscountAmount || amountConfig
            ? `<div class="order-remark">
            ${orderData.DiscountAmount ? `<div style="width:25%;">优惠金额：${orderData.DiscountAmount}</div>` : ''}
            ${orderData.DiscountAmount ? `<div style="width:25%;">应付总额：${(orderData.GoodsAmount - orderData.DiscountAmount).toFixed(2)}</div>` : ''}
            ${amountConfig ? `<div style="width:50%;" v-if="amountConfig">金额总计（大写）：${capitalAmount}</div></div>` : ''} 
             </div>`
            : ''
    }
    ${
        orderData.Remark
            ? `<div class="order-remark">
                <div>备注：${orderData.Remark}</div>
              </div>`
            : ''
    }
    ${footnoteConfig != null && footnoteConfig.Result ? `<div class="order-remark">${footnoteConfig.RValue}</div>` : ''}
    
</div>
                  `;

    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 12px 0;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }       
        .order-detail {
            color: #000;
        }

        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding-top: 10px;
            color: #000;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 50%;
            margin: 0 auto;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
        }
        .print-zone {
            width: 200mm;
        }

        .print-table-main {
            width: 762px;
            font-size: 12px;
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }
        .fdzt {
            font-size: 14px;
        }
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成锦盛销售单打印页面
 * orderData：订单数据
 * titleConfig：标题配置
 * nameConfig：打印业务员配置
 * footnoteConfig：脚注配置
 * amountConfig：启动打印总计金额大写配置
 * capitalAmount：订单大写总金额
 */
function buildJSSalesPrintHtml(orderData, titleConfig, nameConfig, footnoteConfig, amountConfig, capitalAmount) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">${index + 1}</div>
            <div class="div-table-cell" style="width: 18%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
            <div class="div-table-cell fdzt" style="width: 6%">${AP.Count}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell" style="width: 8%">${AP.Price}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${(AP.Count * AP.Price).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 13%">${AP.GoodsLocation}</div>   
            </div>          
            `;
        });
    }
    let printContent = `
    <div class="print-for">
    <div class="print-title-view">
        <div class="print-title">${titleConfig.RValue}</div>
        <div class="order-detail code">单号：${orderData.OrderCode}</div>
        <div class="order-detail time">日期：${orderData.CreateTime}</div>
    </div>
    <div class="print-table-main">
        <div class="div-table-row">
            <div class="div-table-cell" style="width:80px">客户名称</div>
            <div class="div-table-cell fdzt" style="flex:1">${orderData.EntpCusName}</div>
            <div class="div-table-cell" style="width:80px">电话</div>
            <div class="div-table-cell fdzt" style="flex:1">${orderData.PhoneNum}</div>            
        </div>
        ${
            orderData.LogisticName
                ? ` <div class="div-table-row">
                        <div class="div-table-cell" style="width:80px">物流公司</div>
                        <div class="div-table-cell" style="flex:1">
                            ${orderData.LogisticName}
                        </div>
                    </div>`
                : ''
        }
        <div class="div-table-row">
            <div class="div-table-cell" style="width:80px">客户地址</div>
            <div class="div-table-cell" style="flex:1">${orderData.FullAddress}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">序号</div>
            <div class="div-table-cell" style="width: 18%">汽配编码</div>
            <div class="div-table-cell" style="width: 16%">配件名称</div>
            <div class="div-table-cell" style="width: 20%">车型</div>
            <div class="div-table-cell" style="width: 6%">数量</div>
            <div class="div-table-cell" style="width: 6%">单位</div>
            <div class="div-table-cell" style="width: 8%">售价</div>
            <div class="div-table-cell" style="width: 12%">销售总价</div>
            <div class="div-table-cell" style="width: 13%">仓位</div>
        </div>
        ${tableConten}
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell" style="width: 18%"></div>
            <div class="div-table-cell" style="width: 16%"></div>
            <div class="div-table-cell pall-count" style="width: 20%">总数量 &nbsp;</div>
            <div class="div-table-cell" style="width: 6%">${orderData.TotalCount}</div>
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell pall-count" style="width: 8%">总价 &nbsp;</div>
            <div class="div-table-cell" style="width: 12%">${(orderData.GoodsAmount + orderData.ShipAmount).toFixed(2)}</div>
            <div class="div-table-cell" style="width: 13%"></div>
        </div>
    </div>

    </div>
    <div class="order-remark">
        <div style="width:16.66667%;">运费：${orderData.ShipAmount}</div>
        <div style="width:25%;">支付方式：${orderData.PayTypeName}</div>
        <div style="width:25%;">发货方式：${orderData.ShipTypeName}</div>
        <div style="width:16.66667%;">业务员：${nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName}</div>
        <div style="width:16.66667%;">备货员：</div>
    </div>
    ${
        orderData.DiscountAmount || amountConfig
            ? `<div class="order-remark">
            ${orderData.DiscountAmount ? `<div style="width:25%;">优惠金额：${orderData.DiscountAmount}</div>` : ''}
            ${orderData.DiscountAmount ? `<div style="width:25%;">应付总额：${(orderData.GoodsAmount - orderData.DiscountAmount).toFixed(2)}</div>` : ''}
            ${amountConfig ? `<div style="width:50%;" v-if="amountConfig">金额总计（大写）：${capitalAmount}</div></div>` : ''} 
             </div>`
            : ''
    }
    ${
        orderData.Remark
            ? `<div class="order-remark">
                <div>备注：${orderData.Remark}</div>
              </div>`
            : ''
    }
    ${footnoteConfig != null && footnoteConfig.Result ? `<div class="order-remark">${footnoteConfig.RValue}</div>` : ''}
    
</div>
                  `;

    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 64px 0 12px;
            margin-bottom:10px;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }       
        .order-detail {
            color: #000;
        }
        .code{
            position: absolute;
            bottom: 0;
        }
        .time{
            position: absolute;
            right: 0;
            bottom: 0;
        }
        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding-top: 10px;
            color: #000;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 50%;
            margin: 0 auto;
            text-align: center;
            font-size: 28px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
        }
        .print-zone {
            width: 200mm;
        }

        .print-table-main {
            width: 762px;
            font-size: 12px;
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
  
        }
        .fdzt {
            font-size: 14px;
        }
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成公共销售单打印页面
 * orderData：订单数据
 * titleConfig：标题配置
 * nameConfig：打印业务员配置
 * footnoteConfig：脚注配置
 * amountConfig：启动打印总计金额大写配置
 * capitalAmount：订单大写总金额
 */
function buildSalesPrintHtml(orderData, titleConfig, nameConfig, footnoteConfig, amountConfig, capitalAmount) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">${index + 1}</div>
            <div class="div-table-cell" style="width: 18%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 18%">适用:${AP.AutoSerise}</div>
            <div class="div-table-cell fdzt" style="width: 6%">${AP.Count}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell" style="width: 10%">${AP.Price}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${(AP.Count * AP.Price).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 13%">${AP.GoodsLocation}</div>   
            </div>          
            `;
        });
    }
    let printContent = `
    <div class="print-for">
    <div class="print-title-view">
        <div class="order-code"></div>
        <div class="print-title">${titleConfig ? titleConfig.RValue : '销售单'}</div>
        <div class="order-detail">
            <div class="right">单号：${orderData.OrderCode}</div>
            <div class="right">
                日期：
                <span>${orderData.CreateTime}</span>
            </div>
        </div>
    </div>
    <div class="print-table-main">
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户名称</div>
            <div class="div-table-cell fdzt" style="width: 80%">${orderData.EntpCusName}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 20%">客户地址</div>
            <div class="div-table-cell" style="width: 80%">${orderData.FullAddress}</div>
        </div>
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%">序号</div>
            <div class="div-table-cell" style="width: 18%">汽配编码</div>
            <div class="div-table-cell" style="width: 16%">配件名称</div>
            <div class="div-table-cell" style="width: 18%">车型</div>
            <div class="div-table-cell" style="width: 6%">数量</div>
            <div class="div-table-cell" style="width: 6%">单位</div>
            <div class="div-table-cell" style="width: 10%">售价</div>
            <div class="div-table-cell" style="width: 12%">销售总价</div>
            <div class="div-table-cell" style="width: 13%">仓位</div>
        </div>
        ${tableConten}
        <div class="div-table-row">
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell" style="width: 18%"></div>
            <div class="div-table-cell" style="width: 16%"></div>
            <div class="div-table-cell pall-count" style="width: 18%">总数量 &nbsp;</div>
            <div class="div-table-cell" style="width: 6%">${orderData.TotalCount}</div>
            <div class="div-table-cell" style="width: 6%"></div>
            <div class="div-table-cell pall-count" style="width: 10%">总价 &nbsp;</div>
            <div class="div-table-cell" style="width: 12%">${(orderData.GoodsAmount + orderData.ShipAmount).toFixed(2)}</div>
            <div class="div-table-cell" style="width: 13%"></div>
        </div>
    </div>

    </div>
    <div class="order-remark">
        <div style="width:16.66667%;">运费：${orderData.ShipAmount}</div>
        <div style="width:25%;">支付方式：${orderData.PayTypeName}</div>
        <div style="width:25%;">发货方式：${orderData.ShipTypeName}</div>
        <div style="width:16.66667%;">业务员：${nameConfig ? (orderData.SNickName ? orderData.SNickName : orderData.SName) : orderData.SName}</div>
        <div style="width:16.66667%;">备货员：</div>
    </div>
    ${
        orderData.DiscountAmount || amountConfig
            ? `<div class="order-remark">
            ${orderData.DiscountAmount ? `<div style="width:25%;">优惠金额：${orderData.DiscountAmount}</div>` : ''}
            ${orderData.DiscountAmount ? `<div style="width:25%;">应付总额：${(orderData.GoodsAmount - orderData.DiscountAmount).toFixed(2)}</div>` : ''}
            ${amountConfig ? `<div style="width:50%;" v-if="amountConfig">金额总计（大写）：${capitalAmount}</div></div>` : ''} 
             </div>`
            : ''
    }
    ${
        orderData.Remark
            ? `<div class="order-remark">
                <div>备注：${orderData.Remark}</div>
              </div>`
            : ''
    }
    ${footnoteConfig != null && footnoteConfig.Result ? `<div class="order-remark">${footnoteConfig.RValue}</div>` : ''}
    
</div>
                  `;

    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 12px 0;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }       
        .order-detail {
            color: #000;
        }

        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding-top: 10px;
            color: #000;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-width: 50%;
            margin: 0 auto;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
        }
        .print-zone {
            width: 200mm;
        }

        .print-table-main {
            width: 762px;
            font-size: 12px;
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }
        .fdzt {
            font-size: 14px;
        }
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成海口应收帐单据打印页面
 * @param {*订单列表} orderList
 * @returns html
 */
function buildCusRecePrintHtml(orderList, employeeName) {
    let tableConten = '';
    let allPrice = 0;
    let allPrice1 = 0;
    if (orderList && orderList.length > 0) {
        orderList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell tcen" style="width: 5%">${Number(index) + 1}</div>
            <div class="div-table-cell" style="width: 25%">${AP.EntpCusName}</div>
            <div class="div-table-cell" style="width: 9%">${AP.OrderType == 0 ? '销售收款' : AP.OrderType == 1 ? '销售退货' : '建账'}</div>
            <div class="div-table-cell" style="width: 20%">${AP.OrderCode}</div>
            <div class="div-table-cell" style="width: 10%">${AP.CreateTime}</div>
            <div class="div-table-cell tright" style="width: 15.5%">${AP.OrderType != 1 ? AP.TotalAmount : -AP.TotalAmount}</div>
            <div class="div-table-cell tright" style="width: 15.5%">${
                AP.OrderType != 1
                    ? AP.IsAgent
                        ? (AP.TotalAmount - AP.AgentAmount - AP.AlreadyPaid).toFixed(2)
                        : (AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
                    : -(AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
            }</div>
        </div>
            `;
            if (AP.OrderType != 1) allPrice += AP.TotalAmount;
            else allPrice += -AP.TotalAmount;

            allPrice1 += Number(
                AP.OrderType != 1
                    ? AP.IsAgent
                        ? (AP.TotalAmount - AP.AgentAmount - AP.AlreadyPaid).toFixed(2)
                        : (AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
                    : -(AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
            );
        });
    }
    allPrice = allPrice.toFixed(2);
    allPrice1 = allPrice1.toFixed(2);
    let d = new Date();
    let year1, month1, day1;
    [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
    let printDate = `${year1}-${month1}-${day1}`;
    let printContent = `
    <div>
        <div class="print-title-view">
            <div class="print-title">海口茂通发达汽配(龙华总仓)出库对账单</div>
        </div>
        <div class="print-table-main">
            <div class="div-table-row">
                <div class="div-table-cell theader" style="width: 5%">序号</div>
                <div class="div-table-cell theader" style="width: 25%">客户名称</div>
                <div class="div-table-cell theader" style="width: 9%">单据</div>
                <div class="div-table-cell theader" style="width: 20%">单据号</div>
                <div class="div-table-cell theader" style="width: 10%">单据日期</div>
                <div class="div-table-cell theader" style="width: 15.5%">挂账金额</div>
                <div class="div-table-cell theader" style="width: 15.5%">欠款余额</div>
            </div>
            ${tableConten}
            <div class="div-table-row">
                <div class="div-table-cell theader" style="width: 30%">合计</div>
                <div class="div-table-cell" style="width: 9%"></div>
                <div class="div-table-cell" style="width: 20%"></div>
                <div class="div-table-cell" style="width: 10%"></div>
                <div class="div-table-cell theader tright" style="width: 15.5%">${allPrice}</div>
                <div class="div-table-cell theader tright" style="width: 15.5%">${allPrice1}</div>
            </div>
        </div>
        <div class="order-remark">
            <div style="width:40%;"></div>
            <div style="width:40%;"></div>
            <div style="width:20%;">打印日期：${printDate}</div>
        </div>
        <div class="order-remark">
            <div style="width:40%;" class="uline">账单签收人：</div>
            <div style="width:40%;" class="uline sec">付款时间确认：</div>
            <div style="width:20%;text-indent: 6px;">制单人：${employeeName}</div>
        </div>
        <div class="order-remark">
            备注：以上账单的原签名（白联单）单据已发出，未付款金额以此账表为准。
        </div>  
        <div style="text-align: center;padding: 10px 60px;font-size: 16px;color: #000;font-weight: bold;">
            <div style="border: 1px solid #000;padding: 3px 0px;">
                <div style="width:20%;display: inline-block;">年</div>
                <div style="width:40%;display: inline-block;">账单合计金额：</div>
                <div style="width:20%;display: inline-block;">元</div>
            </div>
        </div>              
    </div>
    `;
    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>应收账单打印</title>

        <style type="text/css">
            .print-zone {
                width: 210mm;
            }
            .print-title-view {
                width: 762px;
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                padding: 20px 0;
            }

            .print-title-view .print-title {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 50%;
                margin: 0 auto;
                text-align: center;
                font-size: 20px;
                font-weight: bold;
                color: #000;
                min-height: 26px;
            }
            .print-table-main {
                width: 762px;
                font-size: 14px;
            }
            .print-table-main .theader {
                text-align: center;
                font-weight: bold;
            }
            .print-table-main .tcen {
                text-align: center;
            }
            .print-table-main .tright {
                text-align: right;
                padding-right: 5px;
            }
            .print-table-main .div-table-cell {
                overflow: hidden;
                word-break: break-all;
                word-wrap: break-word;
                height: auto;
                line-height: 25px;
                padding-left: 1px;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                border-bottom: 1px solid #000;
                color: #000;
                box-sizing: border-box;
            }
            .print-table-main .div-table-row {
                display: flex;
                border-left: 1px solid #000;
                margin: 0;
            }
            .order-remark {
                width: 752px;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                color: #000;
                font-weight: bold;
                padding: 5px 10px 5px 10px;
                    position: relative;
            }
            .pdate {
                text-align: right;
                display: block;
            }
            .uline {
                position: relative;
                margin-right: 20px;
            }
            .uline::after {
                content: '';
                width: 65%;
                height: 3px;
                
                position: absolute;
               
                left: 85px;
                bottom: 0px;
                border-bottom: 1px solid #000;
            }
            .sec::after {
                left: 103px;
            }              
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成海口应付帐单据打印页面
 * @param {*订单列表} orderList
 * @returns html
 */
function buildSupPayPrintHtml(orderList, employeeName) {
    let tableConten = '';
    let allPrice = 0;
    let allPrice1 = 0;
    if (orderList && orderList.length > 0) {
        orderList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
            <div class="div-table-cell tcen" style="width: 4%">${Number(index) + 1}</div>
            <div class="div-table-cell" style="width: 25%">${AP.EntpCusName}</div>
            <div class="div-table-cell" style="width: 9%">${AP.OrderType == 0 ? '采购付款' : AP.OrderType == 1 ? '采购退货' : '建账'}</div>
            <div class="div-table-cell" style="width: 18%">${AP.OrderCode}</div>
            <div class="div-table-cell" style="width: 9%">${AP.ConfirmTime}</div>
            <div class="div-table-cell tright" style="width: 17.5%">${AP.OrderType != 1 ? AP.TotalAmount : -AP.TotalAmount}</div>
            <div class="div-table-cell tright" style="width: 17.5%">${
                AP.OrderType != 1 ? (AP.TotalAmount - AP.AlreadyPaid).toFixed(2) : -(AP.TotalAmount - AP.AlreadyPaid).toFixed(2)
            }</div>
        </div>
            `;
            if (AP.OrderType != 1) allPrice += AP.TotalAmount;
            else allPrice += -AP.TotalAmount;
            allPrice1 += Number(AP.OrderType != 1 ? (AP.TotalAmount - AP.AlreadyPaid).toFixed(2) : -(AP.TotalAmount - AP.AlreadyPaid).toFixed(2));
        });
    }
    allPrice = allPrice.toFixed(2);
    let d = new Date();
    let year1, month1, day1;
    [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, d.getDate()];
    let printDate = `${year1}-${month1}-${day1}`;
    let printContent = `
    <div>
        <div class="print-title-view">
            <div class="print-title">海口茂通发达汽配(龙华总仓)应付帐管理</div>
        </div>
        <div class="print-table-main">
            <div class="div-table-row">
                <div class="div-table-cell theader" style="width: 4%">序号</div>
                <div class="div-table-cell theader" style="width: 25%">供应商名称</div>
                <div class="div-table-cell theader" style="width: 9%">单据</div>
                <div class="div-table-cell theader" style="width: 18%">单据号</div>
                <div class="div-table-cell theader" style="width: 9%">挂账日期</div>
                <div class="div-table-cell theader" style="width: 17.5%">挂账金额</div>
                <div class="div-table-cell theader" style="width: 17.5%">欠款余额</div>
            </div>
            ${tableConten}
            <div class="div-table-row">
                <div class="div-table-cell theader" style="width: 29%">合计</div>
                <div class="div-table-cell" style="width: 9%"></div>
                <div class="div-table-cell" style="width: 18%"></div>
                <div class="div-table-cell" style="width: 9%"></div>
                <div class="div-table-cell theader tright" style="width: 17.5%">${allPrice}</div>
                <div class="div-table-cell theader tright" style="width: 17.5%">${allPrice1}</div>
            </div>
        </div>
        <div class="order-remark">
            <div style="width:40%;"></div>
            <div style="width:40%;"></div>
            <div style="width:20%;">打印日期：${printDate}</div>
        </div>
        <div class="order-remark">
            <div style="width:40%;" class="uline">账单签收人：</div>
            <div style="width:40%;" class="uline sec">付款时间确认：</div>
            <div style="width:20%;text-indent: 6px;">制单人：${employeeName}</div>
        </div>
        <div class="order-remark">
            备注：以上账单的原签名（白联单）单据已发出，未付款金额以此账表为准。
        </div>
        <div style="text-align: center;padding: 10px 60px;font-size: 16px;color: #000;font-weight: bold;">
            <div style="border: 1px solid #000;padding: 3px 0px;">
                <div style="width:20%;display: inline-block;">年</div>
                <div style="width:40%;display: inline-block;">账单合计金额：</div>
                <div style="width:20%;display: inline-block;">元</div>
            </div>
        </div>                  
    </div>
    `;
    let template = `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>应付账单打印</title>

        <style type="text/css">
            .print-zone {
                width: 210mm;
            }
            .print-title-view {
                width: 762px;
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                padding: 20px 0;
            }

            .print-title-view .print-title {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                max-width: 50%;
                margin: 0 auto;
                text-align: center;
                font-size: 20px;
                font-weight: bold;
                color: #000;
                min-height: 26px;
            }
            .print-table-main {
                width: 762px;
                font-size: 12px;
            }
            .print-table-main .theader {
                text-align: center;
                font-weight: bold;
            }
            .print-table-main .tcen {
                text-align: center;
            }
            .print-table-main .tright {
                text-align: right;
                padding-right: 5px;
            }
            .print-table-main .div-table-cell {
                overflow: hidden;
                word-break: break-all;
                word-wrap: break-word;
                height: auto;
                line-height: 25px;
                padding-left: 1px;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                border-bottom: 1px solid #000;
                color: #000;
                box-sizing: border-box;
            }
            .print-table-main .div-table-row {
                display: flex;
                border-left: 1px solid #000;
                margin: 0;
            }
            .order-remark {
                width: 752px;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                color: #000;
                font-weight: bold;
                padding: 5px 10px 5px 10px;
                    position: relative;
            }
            .pdate {
                text-align: right;
                display: block;
            }
            .uline {
                position: relative;
                margin-right: 20px;
            }
            .uline::after {
                content: '';
                width: 65%;
                height: 3px;
                
                position: absolute;
               
                left: 85px;
                bottom: 0px;
                border-bottom: 1px solid #000;
            }
            .sec::after {
                left: 103px;
            }               
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成海口采购单打印页面
 * orderData：订单数据
 * capitalAmount：订单大写总金额
 */
function buildHKPurchasePrintHtml(orderData, capitalAmount) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row tableConten">
            <div class="div-table-cell" style="width: 4%">${index + 1}</div>
            <div class="div-table-cell" style="width: 16%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 18%">${AP.AutoSerise}</div>
            <div class="div-table-cell" style="width: 10%">${AP.Size}</div>
            <div class="div-table-cell" style="width: 8%">${AP.Origin}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell fdzt" style="width: 6%">${AP.Count}</div>
            <div class="div-table-cell fdzt" style="width: 10%">${AP.Price}</div>
            <div class="div-table-cell fdzt" style="width: 12%">${(AP.Count * AP.Price).toFixed(2)}</div>
            </div>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div  class="print-title">海口茂通发达汽配(龙华总仓)采购单</div>
                        </div>
                        <div class="print-orderDetail">
                            <div class="row">
                                <div class="col col-9">
                                    <label class="label_l">供应单位：</label>
                                    <div class="grid-content">${orderData.EntpCusName}</div>
                                </div>
                                <div class="col col-6">
                                    <label class="label_l">支付方式：</label>
                                    <div class="grid-content">${orderData.PayTypeName}</div>
                                </div>
                                <div class="col col-6 barfa">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-9">
                                    <label class="label_l">单据日期：</label>
                                    <div class="grid-content">${orderData.CreateTime}</div>
                                </div>
                                <div class="col col-6">
                                    <label class="label_l">发货方式：</label>
                                    <div class="grid-content">${orderData.ShipTypeName}</div>
                                </div>
                            </div>
                            <div class="row">
                               <div class="col rkCol">
                                <label class="label_r">备注：</label>
                                <div class="grid-content">${orderData.Remark}</div>
                            </div>
                       </div>                            
                    </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 4%">序</div>
                                <div class="div-table-cell" style="width: 16%">编码</div>
                                <div class="div-table-cell" style="width: 16%">名称</div>
                                <div class="div-table-cell" style="width: 18%">车型</div>
                                <div class="div-table-cell" style="width: 10%">规格</div>
                                <div class="div-table-cell" style="width: 8%">产地</div>
                                <div class="div-table-cell" style="width: 6%">单位</div>
                                <div class="div-table-cell" style="width: 6%">数量</div>
                                <div class="div-table-cell" style="width: 10%">进价</div>
                                <div class="div-table-cell" style="width: 12%">金额</div>
                            </div>
                            ${tableConten}
                        </div>
                        <div class="order-remark btd">
                            <div style="width:70.33333%;">人民币大写：${capitalAmount}</div>
                            <div style="width:20.66667%;">${orderData.ShipAmount > 0 ? '运费：' + orderData.ShipAmount : ''}</div>
                            <div style="width:20.66667%;">数量：${orderData.TotalCount}</div>
                            <div style="width:20.66667%;">金额：${orderData.SurplusMoney}</div>
                        </div>
                        <div class="order-remark fwb">
                            <div>开单人：${orderData.SName}</div>
                        </div>                        
                    </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>采购单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 790px;
            position: relative;
            justify-content: space-between;
            align-items: flex-end;
            padding: 0;
        }
        .order-detail {
            color: #000;
            padding-right: 30px;
        }
        .order-remark {
            width: 762px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-top: 5px;
            color: #000;
        }
        .print-title {
            margin: 0 auto;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
            padding-bottom: 5px;
        }
        .print-zone {
            width: 200mm;
        }
        .print-table-main {
            width: 762px;
            font-size: 14px;
        }
        .print-table-main .div-table-cell {
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
            height: auto;
            line-height: 25px;
            padding-left: 1px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .print-table-main .tableConten .div-table-cell {
            line-height: 14px;
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            /*box不兼容是用下面*/
            display: flex;
            align-items: center;
            padding-bottom: 5px;
            padding-top: 5px;            
        }
        .print-table-main .div-table-row {
            display: flex;
            border-left: 1px solid #000;
        }
        .fdzt {
            font-size: 14px;
        }
        .fwb {
            font-weight: bold;
        }
        .btd {
            border-bottom: 1px dashed #000;
            font-weight: bold;
            font-size: 15px;
        }                
        .print-orderDetail {
            width: 762px;
            margin-bottom: 10px;
            font-size: 14px;
            color: #000;
            padding: 0;
            padding-left: 5px;
            margin-right: 20px;
        }
        .print-orderDetail .barfa{
            display:none;
        }
        .print-orderDetail .row {
            margin-left: -10px;
            margin-right: -10px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-bottom: 5px;
        }
        .print-orderDetail .row:last-child{
            margin-bottom: 0px;
        }                    
        .print-orderDetail .row::after,
        .print-orderDetail .row::before {
            display: table;
            content: '';
            clear: both;
        }
        .print-orderDetail .row .col {
            float: left;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            line-height: 18px;
            height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .print-orderDetail .col-5 {
            width: 20.83333%;
        }
        .print-orderDetail .col-6 {
            width: 25%;
        }
        .print-orderDetail .col-7 {
            width: 29.16667%;
        }
        .print-orderDetail .col-8 {
            width: 33.33333%
        }
        .print-orderDetail .col-9 {
            width: 37.5%;
        }   
        .print-orderDetail .row .height40 {
            height: 40px !important;
        }

        .print-orderDetail .row .col .label_l {
            width: 70px;
            text-align: left;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .print-orderDetail .row .col .label_r {
            width: 70px;
            text-align: right;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .w60{width:60px !important;}
        .print-orderDetail .row .col .grid-content {
            display: inline-block;
            min-height: 18px;
            border-radius: unset;
            line-height: 18px;
        } 
        .print-orderDetail .row .col .debts{
            padding-top: 3px;
        }
        .print-orderDetail .row .col .grid-content::after,
        .print-orderDetail .row .col .grid-content::before {
            display: table;
            content: '';
            clear: both;
        } 
        .print-orderDetail .rkCol{
            height: auto !important;
        }
        .print-orderDetail .rkCol .grid-content{
            overflow: hidden !important;
            word-break: break-all !important;
            word-wrap: break-word !important;
            white-space: break-spaces !important;
            white-space: pre-wrap !important;
            width: 65% !important;
        }          
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

//计算分摊价
function calcShare(dataList, orderData) {
    let costTotal = 0;
    let supTotal = 0;
    let supCount = 0;
    let list = dataList;
    let selfData = orderData.CostItems;
    if (selfData.length > 0) {
        selfData.forEach(item => {
            if (!isNaN(item.value)) {
                costTotal += Number(item.value);
            } else {
                costTotal += 0;
            }
        });
        if (costTotal > 0) {
            list.forEach(item => {
                supTotal += item.Price;
                supCount += item.Count;
            });

            dataList.forEach(item => {
                if (orderData.calcType == 0) {
                    item.ShareCost = Number((item.Price * (costTotal / supTotal)) / item.Count);
                } else {
                    item.ShareCost = Number(costTotal / supCount);
                }
            });
        }
    }
    return dataList;
}
/**
 * 生成崇峰采购单打印页面
 * orderData：订单数据
 */
function buildCFPurchasePrintHtml(orderData) {
    let tableConten = '';
    let _allNum = 0;
    let _allPrice = 0;
    let ShareCostTotalPrice = 0;
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList = calcShare(orderData.DetailList, orderData);
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">        
                <div class="div-table-cell" style="width: 6%">${index + 1}</div>
                <div class="div-table-cell" style="width: 16%">${AP.APCode}</div>
                <div class="div-table-cell" style="width: 21%">${AP.GoodName}</div>
                <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
                <div class="div-table-cell" style="width: 6%">${AP.Count}</div>
                <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
                <div class="div-table-cell" style="width: 10%">${AP.Price}</div>
                <div class="div-table-cell" style="width: 10%">${(AP.ShareCost + AP.Price).toFixed(2) * 1}</div>
                <div class="div-table-cell" style="width: 15%">${AP.GoodsLocation}</div>            
            </div>
            `;
            _allNum += AP.Count;
            _allPrice += AP.Count * AP.Price;
            ShareCostTotalPrice += AP.Count * (AP.Price + AP.ShareCost);
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div class="order-code"></div>
                            <div class="print-title">供应商采购单</div>
                            <div class="company">
                                <div>单号：${orderData.OrderCode}</div>
                                <div>单位：${orderData.company}</div>
                            </div>
                        </div>  
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell hhead" style="width: 20%;">客户名称</div>
                                <div class="div-table-cell hhead" style="width: 80%">${orderData.EntpCusName}</div>
                            </div>                        
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%">序号</div>
                                <div class="div-table-cell" style="width: 16%">汽配编码</div>
                                <div class="div-table-cell" style="width: 21%">配件名称</div>
                                <div class="div-table-cell" style="width: 20%">车型</div>
                                <div class="div-table-cell" style="width: 6%">数量</div>
                                <div class="div-table-cell" style="width: 6%">单位</div>
                                <div class="div-table-cell" style="width: 10%">采购价</div>
                                <div class="div-table-cell" style="width: 10%">分摊价</div>
                                <div class="div-table-cell" style="width: 15%">仓位</div>
                            </div>
                            ${tableConten}
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%"></div>
                                <div class="div-table-cell" style="width: 16%"></div>
                                <div class="div-table-cell" style="width: 21%"></div>
                                <div class="div-table-cell" style="width: 20%">总数量</div>
                                <div class="div-table-cell" style="width: 6%">${_allNum}</div>
                                <div class="div-table-cell" style="width: 6%">总价</div>
                                <div class="div-table-cell" style="width: 10%">${_allPrice}</div>
                                <div class="div-table-cell" style="width: 10%"> ${ShareCostTotalPrice}</div>
                                <div class="div-table-cell" style="width: 15%"></div>
                            </div>                            
                        </div>
                        <div class="order-remark">
                             <div>${orderData.Remark ? '备注：' + orderData.Remark : ''}</div>
                        </div>
                     </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>采购单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 12px 0;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }
        .qrcode-canvas,
        .qrcode-image {
            display: none;
        }

        .order-detail {
            color: #000;
        }
        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 0px 0px 15px 0px;
            color: #000;
        }
        .company {
            color: #000;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
        }
        .print-table-main {
            width: 762px;
            font-size: 14px;
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }
        .hhead {
            padding-left: 0px;
            text-indent: 10px;
        }
        .hhead:first-of-type{
            padding-left: 1px;
        }          
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成公共采购单打印页面
 * orderData：订单数据
 */
function buildPurchasePrintHtml(orderData) {
    let tableConten = '';
    let _allNum = 0;
    let _allPrice = 0;
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">        
                <div class="div-table-cell" style="width: 6%">${index + 1}</div>
                <div class="div-table-cell" style="width: 16%">${AP.APCode}</div>
                <div class="div-table-cell" style="width: 21%">${AP.GoodName}</div>
                <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
                <div class="div-table-cell" style="width: 6%">${AP.Count}</div>
                <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
                <div class="div-table-cell" style="width: 10%">${AP.Price}</div>
                <div class="div-table-cell" style="width: 15%">${AP.GoodsLocation}</div>     
                <div class="div-table-cell" style="width: 10%">${AP.Remark}</div>       
            </div>
            `;
            _allNum += AP.Count;
            _allPrice += AP.Count * AP.Price;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div class="order-code"></div>
                            <div class="print-title">供应商采购单</div>
                            <div class="company">
                                <div>单号：${orderData.OrderCode}</div>
                                <div>单位：${orderData.company}</div>
                            </div>
                        </div>  
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell hhead" style="width: 20%;">客户名称</div>
                                <div class="div-table-cell hhead" style="width: 80%">${orderData.EntpCusName}</div>
                            </div>   
                            <div class="div-table-row">
                                <div class="div-table-cell hhead" style="width: 20%;">联系电话</div>
                                <div class="div-table-cell hhead" style="width: 80%"></div>
                            </div>                                                  
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%">序号</div>
                                <div class="div-table-cell" style="width: 16%">汽配编码</div>
                                <div class="div-table-cell" style="width: 21%">配件名称</div>
                                <div class="div-table-cell" style="width: 20%">车型</div>
                                <div class="div-table-cell" style="width: 6%">数量</div>
                                <div class="div-table-cell" style="width: 6%">单位</div>
                                <div class="div-table-cell" style="width: 10%">采购价</div>
                                <div class="div-table-cell" style="width: 15%">仓位</div>
                                <div class="div-table-cell" style="width: 10%">备注</div>
                            </div>
                            ${tableConten}
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%"></div>
                                <div class="div-table-cell" style="width: 16%"></div>
                                <div class="div-table-cell" style="width: 21%"></div>
                                <div class="div-table-cell" style="width: 20%">总数量</div>
                                <div class="div-table-cell" style="width: 6%">${_allNum}</div>
                                <div class="div-table-cell" style="width: 6%">总价</div>
                                <div class="div-table-cell" style="width: 10%">${_allPrice}</div>
                                <div class="div-table-cell" style="width: 15%"></div>
                                <div class="div-table-cell" style="width: 10%"></div>
                            </div>                            
                        </div>
                        <div class="order-remark">
                             <div>${orderData.Remark ? '备注：' + orderData.Remark : ''}</div>
                        </div>
                     </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>采购单打印</title>

        <style type="text/css">
        .print-title-view {
            width: 762px;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            padding: 12px 0;
        }
        .order-code {
            width: 80px;
            height: 80px;
            display: inline-block;
            vertical-align: top;
        }
        .qrcode-canvas,
        .qrcode-image {
            display: none;
        }

        .order-detail {
            color: #000;
        }
        .order-remark {
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 0px 0px 15px 0px;
            color: #000;
        }
        .company {
            color: #000;
        }
        .print-title {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
        }
        .print-table-main {
            width: 762px;
            font-size: 14px;
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }
        .hhead {
            padding-left: 0px;
            text-indent: 10px;
        }
        .hhead:first-of-type{
            padding-left: 1px;
        }          
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成海口销售售后打印页面
 * orderData：订单数据
 * capitalAmount：订单大写总金额
 */
function buildHKSaleReturnPrintHtml(orderData, capitalAmount, footnoteConfig) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row tableConten">
            <div class="div-table-cell" style="width: 4%">${index + 1}</div>
            <div class="div-table-cell" style="width: 16%">${AP.APCode}</div>
            <div class="div-table-cell" style="width: 16%">${AP.GoodName}</div>
            <div class="div-table-cell" style="width: 18%">${AP.AutoSerise}</div>
            <div class="div-table-cell" style="width: 10%">${AP.Size}</div>
            <div class="div-table-cell" style="width: 8%">${AP.Origin}</div>
            <div class="div-table-cell" style="width: 6%">${AP.Unit}</div>
            <div class="div-table-cell fdzt" style="width: 6%">-${AP.ReturnCount}</div>
            <div class="div-table-cell fdzt" style="width: 10%">${AP.ReturnPrice}</div>
            <div class="div-table-cell fdzt" style="width: 12%">-${(AP.ReturnCount * AP.ReturnPrice).toFixed(2)}</div>
            <div class="div-table-cell fdzt" style="width: 13%">${AP.Remark}</div>
            </div>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div  class="print-title">海口茂通发达汽配(龙华总仓)销售退货单</div>
                        </div>
                        <div class="print-orderDetail">
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">客户名称：</label>
                                    <div class="grid-content">${orderData.EntpCusName}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">退款方式：</label>
                                    <div class="grid-content">${orderData.PayTypeName}</div>
                                </div>
                                <div class="col col-6 barfa">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">客户电话：</label>
                                    <div class="grid-content">${orderData.PhoneNum}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">是否欠款：</label>
                                    <div class="grid-content debts">${orderData.IsDebts ? '**' : ''}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">客户类型：</label>
                                    <div class="grid-content">${orderData.CusType}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">退货日期：</label>
                                    <div class="grid-content">${orderData.ReturnTime}</div>
                                </div>                        
                            </div>
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">物流公司：</label>
                                    <div class="grid-content">${orderData.LogisticName?orderData.LogisticName:''}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">发货方式：</label>
                                    <div class="grid-content">${orderData.ShipTypeName}</div>
                                </div>                        
                            </div>                                                               
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">部门：</label>
                                    <div class="grid-content">${orderData.OrgName}</div>
                                </div>                             
                                <div class="col rkCol">
                                    <label class="label_r">退货原因：</label>
                                    <div class="grid-content">${orderData.Reasons}</div>
                                </div>
                            </div>                            
                    </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                    <div class="div-table-cell" style="width: 4%">序</div>
                                    <div class="div-table-cell" style="width: 16%">编码</div>
                                    <div class="div-table-cell" style="width: 16%">名称</div>
                                    <div class="div-table-cell" style="width: 18%">车型</div>
                                    <div class="div-table-cell" style="width: 10%">规格</div>
                                    <div class="div-table-cell" style="width: 8%">产地</div>
                                    <div class="div-table-cell" style="width: 6%">单位</div>
                                    <div class="div-table-cell" style="width: 6%">数量</div>
                                    <div class="div-table-cell" style="width: 10%">退货价</div>
                                    <div class="div-table-cell" style="width: 12%">退货总价</div>
                                    <div class="div-table-cell" style="width: 13%">备注</div>
                            </div>
                                ${tableConten}
                        </div>
                            <div class="order-remark btd">
                                <div style="width:70.33333%;">人民币大写：${capitalAmount}</div>
                                <div style="width:20.66667%;"></div>
                                <div style="width:20.66667%;">数量：-${orderData.TotalCount}</div>
                                <div style="width:20.66667%;">金额：-${orderData.TotalRetrunAmount}</div>
                            </div>
                            <div class="order-remark fwb">
                                <div style="width:16.66667%;">开单人：${orderData.Creator}</div>
                                <div style="width:16.66667%;">部门：${orderData.OrgName}</div>
                                <div style="width:16.66667%;"></div>
                                <div style="width:16.66667%;"></div>
                            </div>             
                            <div class="order-remark">${
                                footnoteConfig && footnoteConfig.RValue ? footnoteConfig.RValue.replace(/\n/g, '<br/>') : ''
                            }</div>                                           
                        </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售售后单打印</title>

        <style>
        .print-title-view {
            width: 790px;
            position: relative;
            justify-content: space-between;
            align-items: flex-end;
            padding: 0;
            padding-top:67px;
        }
        .print-title-view .order-code{
            display: none;
        }
        .order-detail {
            color: #000;
            padding-right: 30px;
        }
        .order-remark {
            width: 762px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-top: 3px;
            color: #000;
        }
        .print-title {
            margin: 0 auto;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
            padding-bottom: 5px;
            position: relative;
            top: -10px;
        }
        .print-zone {
            width: 200mm;
        }
        .print-table-main {
            width: 762px;
            font-size: 14px;
        }
        .print-table-main .div-table-cell {
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
            height: auto;
            line-height: 25px;
            padding-left: 1px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .print-table-main .tableConten .div-table-cell {
            line-height: 14px;
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            /*box不兼容是用下面*/
            display: flex;
            align-items: center;
            padding-bottom: 5px;
            padding-top: 5px;                        
        }
        .print-table-main .div-table-row {
            display: flex;
            border-left: 1px solid #000;
        }
        .fdzt {
            font-size: 14px;
        }
        .fwb {
            font-weight: bold;
        }
        .btd {
            border-bottom: 1px dashed #000;
            font-weight: bold;
        }                
        .print-orderDetail {
            width: 762px;
            margin-bottom: 10px;
            font-size: 14px;
            color: #000;
            padding: 0;
            padding-left: 5px;
            margin-right: 20px;
        }
        .print-orderDetail .barfa{
            display:none;
        }
        .print-orderDetail .row {
            margin-left: -10px;
            margin-right: -10px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-bottom: 2px;
        }
        .print-orderDetail .row::after,
        .print-orderDetail .row::before {
            display: table;
            content: '';
            clear: both;
        }
        .print-orderDetail .row .col {
            float: left;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            line-height: 18px;
            height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .print-orderDetail .col-5 {
            width: 20.83333%;
        }
        .print-orderDetail .col-6 {
            width: 25%;
        }
        .print-orderDetail .col-7 {
            width: 29.16667%;
        }
        .print-orderDetail .col-8 {
            width: 33.33333%
        }                    
        .print-orderDetail .qrcode-canvas,
        .print-orderDetail .qrcode-image {
            width: 40px;
            height: 40px;
            display: inline-block;
            vertical-align: top;
        }

        .print-orderDetail .row .height40 {
            height: 40px !important;
        }

        .print-orderDetail .row .col .label_l {
            width: 70px;
            text-align: left;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .print-orderDetail .row .col .label_r {
            width: 70px;
            text-align: right;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .w60{width:60px !important;}
        .print-orderDetail .row .col .grid-content {
            display: inline-block;
            min-height: 18px;
            border-radius: unset;
            line-height: 18px;
        } 
        .print-orderDetail .row .col .debts{
            padding-top: 3px;
        }
        .print-orderDetail .row .col .grid-content::after,
        .print-orderDetail .row .col .grid-content::before {
            display: table;
            content: '';
            clear: both;
        } 
        .print-orderDetail .rkCol{
            height: auto !important;
            width: 65%;
            padding-right: 0px !important;
            overflow: unset !important;
            white-space: unset !important;
            text-overflow: unset !important;
        }
        .print-orderDetail .rkCol .grid-content{
            overflow: hidden !important;
            word-break: break-all !important;
            word-wrap: break-word !important;
            white-space: break-spaces !important;
            white-space: pre-wrap !important;
            width: 85% !important;
        }                                
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成崇峰销售售后打印页面
 * orderData：订单数据
 */
function buildCFSaleReturnPrintHtml(orderData, footnoteConfig) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
                <div class="div-table-cell" style="width: 20%">${AP.APCode}</div>
                <div class="div-table-cell" style="width: 25%">${AP.GoodName}</div>
                <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
                <div class="div-table-cell" style="width: 11%">${AP.ReturnCount}</div>
                <div class="div-table-cell" style="width: 11%">${AP.Unit}</div>
                <div class="div-table-cell" style="width: 13%">${AP.ReturnPrice}</div>
            </div>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title">广州崇峰退货清单</div>
                        <div class="order-detail">
                            <div>退货单号：${orderData.ReturnCode}</div>
                            <div>
                                退货日期：${orderData.ReturnTime}
                            </div>
                        </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 客户名称</div>
                                <div class="div-table-cell" style="width: 80%">${orderData.EntpCusName}</div>
                            </div>
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 客户地址</div>
                                <div class="div-table-cell" style="width: 80%">${orderData.FullAddress ? orderData.FullAddress : ''}</div>
                            </div>                        
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%">汽配编码</div>
                                <div class="div-table-cell" style="width: 25%">配件名称</div>
                                <div class="div-table-cell" style="width: 20%">车型</div>
                                <div class="div-table-cell" style="width: 11%">数量</div>
                                <div class="div-table-cell" style="width: 11%">单位</div>
                                <div class="div-table-cell" style="width: 13%">退单价</div>
                            </div>
                                ${tableConten}
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%"></div>
                                <div class="div-table-cell" style="width: 25%"></div>
                                <div class="div-table-cell pall-count" style="width: 20%">总数量：</div>
                                <div class="div-table-cell" style="width: 11%">${orderData.TotalCount}</div>
                                <div class="div-table-cell pall-count" style="width: 11%">总价：</div>
                                <div class="div-table-cell" style="width: 13%">${orderData.TotalRetrunAmount}</div>
                            </div>                                
                        </div>
                            <div class="order-detail">
                                <div>退款方式：${orderData.PayTypeName}</div>
                                <div">退款金额：${orderData.Paid}</div>
                            </div>
                            <div class="order-remark">
                                <div>退货原因：${orderData.Reasons}</div>
                                <div>开单人：${orderData.Creator}</div>
                            </div>             
                            <div class="order-remark">${
                                footnoteConfig && footnoteConfig.RValue ? footnoteConfig.RValue.replace(/\n/g, '<br/>') : ''
                            }</div>                                           
                        </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售售后单打印</title>

        <style>
        .print-title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
        }
        .order-detail {
            width: 742px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 15px 0;
            color: #000;
        }
        .order-remark {
            width: 742px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 0px 0px 15px 0px;
            color: #000;
        }
        .print-table-main {
            width: 762px;
            margin-left: 1px;
            font-size: 12px;
        }
        .pall-count {
            text-align: right;
            /* padding-right: 10px; */
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }

        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }                                
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成公共销售售后打印页面
 * orderData：订单数据
 */
function buildSaleReturnPrintHtml(orderData, footnoteConfig) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
                <div class="div-table-cell" style="width: 20%">${AP.APCode}</div>
                <div class="div-table-cell" style="width: 25%">${AP.GoodName}</div>
                <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
                <div class="div-table-cell" style="width: 11%">${AP.ReturnCount}</div>
                <div class="div-table-cell" style="width: 11%">${AP.Unit}</div>
                <div class="div-table-cell" style="width: 13%">${AP.ReturnPrice}</div>
            </div>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title">销售退货单</div>
                        <div class="order-detail">
                            <div>退货单号：${orderData.ReturnCode}</div>
                            <div>
                                退货日期：${orderData.ReturnTime}
                            </div>
                        </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 客户名称</div>
                                <div class="div-table-cell" style="width: 80%">${orderData.EntpCusName}</div>
                            </div>
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 客户地址</div>
                                <div class="div-table-cell" style="width: 80%">${orderData.FullAddress ? orderData.FullAddress : ''}</div>
                            </div>                        
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%">汽配编码</div>
                                <div class="div-table-cell" style="width: 25%">配件名称</div>
                                <div class="div-table-cell" style="width: 20%">车型</div>
                                <div class="div-table-cell" style="width: 11%">数量</div>
                                <div class="div-table-cell" style="width: 11%">单位</div>
                                <div class="div-table-cell" style="width: 13%">退单价</div>
                            </div>
                                ${tableConten}
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%"></div>
                                <div class="div-table-cell" style="width: 25%"></div>
                                <div class="div-table-cell pall-count" style="width: 20%">总数量：</div>
                                <div class="div-table-cell" style="width: 11%">${orderData.TotalCount}</div>
                                <div class="div-table-cell pall-count" style="width: 11%">总价：</div>
                                <div class="div-table-cell" style="width: 13%">${orderData.TotalRetrunAmount}</div>
                            </div>                                
                        </div>
                            <div class="order-detail">
                                <div>退款方式：${orderData.PayTypeName}</div>
                                <div">退款金额：${orderData.Paid}</div>
                            </div>
                            <div class="order-remark">
                                <div>退货原因：${orderData.Reasons}</div>
                            </div>             
                            <div class="order-remark">${
                                footnoteConfig && footnoteConfig.RValue ? footnoteConfig.RValue.replace(/\n/g, '<br/>') : ''
                            }</div>                                           
                        </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>销售售后单打印</title>

        <style>
        .print-title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
        }
        .order-detail {
            width: 742px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 15px 0;
            color: #000;
        }
        .order-remark {
            width: 742px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 0px 0px 15px 0px;
            color: #000;
        }
        .print-table-main {
            width: 762px;
            margin-left: 1px;
            font-size: 12px;
        }
        .pall-count {
            text-align: right;
            /* padding-right: 10px; */
        }
        .div-table-cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            height: auto;
            line-height: 30px;
            padding-left: 10px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }

        .div-table-row {
            display: flex;
            border-left: 1px solid #000;
            margin: 0;
            font-size: 14px;
        }                                
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}

/**
 * 生成海口采购售后打印页面
 * orderData：订单数据
 * capitalAmount：订单大写总金额
 */
 function buildHKPurReturnPrintHtml(orderData, capitalAmount, footnoteConfig) {
    let tableConten = '';
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <tr>
                <td>${index + 1}</td>
                <td>${ AP.APCode }</td>
                <td>${ AP.GoodName }</td>
                <td>${ AP.AutoSerise }</td>
                <td>${ AP.Size }</td>
                <td>${ AP.Origin }</td>
                <td>${ AP.Unit }</td>
                <td>-${ AP.ReturnCount }</td>
                <td>${ AP.ReturnPrice }</td>
                <td>-${ (AP.ReturnCount * AP.ReturnPrice).toFixed(2) }</td>
                <td>${ AP.Remark }</td>
            </tr>
            `;
        });
    }
    let printContent = `
                    <div class="print-for">
                        <div class="print-title-view">
                            <div  class="print-title">海口茂通发达汽配(龙华总仓)采购入库退货单</div>
                        </div>
                        <div class="print-orderDetail">
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">供&nbsp;&nbsp;应&nbsp;&nbsp;商：</label>
                                    <div class="grid-content">${orderData.EntpCusName}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">联系电话：</label>
                                    <div class="grid-content">${orderData.PhoneNum}</div>
                                </div>
                                <div class="col col-6 barfa">
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">标&emsp;&emsp;签：</label>
                                    <div class="grid-content">${orderData.CusType}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">部&emsp;&emsp;门：</label>
                                    <div class="grid-content debts">${orderData.OrgName}</div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">退款方式：</label>
                                    <div class="grid-content">${orderData.PayTypeName}</div>
                                </div>
                                <div class="col col-7">
                                    <label class="label_r">退货日期：</label>
                                    <div class="grid-content">${orderData.ReturnTime}</div>
                                </div>                        
                            </div>                                                             
                            <div class="row">
                                <div class="col col-8">
                                    <label class="label_r">发货方式：</label>
                                    <div class="grid-content">${orderData.ShipTypeName}</div>
                                </div>                             
                                <div class="col rkCol">
                                    <label class="label_r">退货原因：</label>
                                    <div class="grid-content">${orderData.Reasons}</div>
                                </div>
                            </div>                            
                    </div>
                        <div class="print-table-main">
                            <table border="1" cellspacing="0" cellpadding="1" width="100%" style="border-collapse: collapse" bordercolor="#333333">
                                <thead>
                                    <tr>
                                        <td width="4%">
                                            <div><b>序</b></div>
                                        </td>
                                        <td width="13.4%">
                                            <div><b>编码</b></div>
                                        </td>
                                        <td width="13.4%">
                                            <div><b>名称</b></div>
                                        </td>
                                        <td width="15.2%">
                                            <div><b>车型</b></div>
                                        </td>
                                        <td width="8.3%">
                                            <div><b>规格</b></div>
                                        </td>
                                        <td width="6.7%">
                                            <div><b>产地</b></div>
                                        </td>
                                        <td width="5.1%">
                                            <div><b>单位</b></div>
                                        </td>
                                        <td width="5.1%">
                                            <div><b>数量</b></div>
                                        </td>
                                        <td width="8.4%">
                                            <div><b>退货价</b></div>
                                        </td>
                                        <td width="10.2%">
                                            <div><b>退货总价</b></div>
                                        </td>
                                        <td width="12.4%">
                                            <div><b>备注</b></div>
                                        </td>
                                    </tr>
                                </thead>    
                                <tbody>  ${tableConten}</tbody>
                            </table>
                        </div>
                            <div class="order-remark btd">
                                <div style="width:57.33333%;">人民币大写：${capitalAmount}</div>
                                <div style="width:16.66667%;">数量：-${orderData.TotalCount}</div>
                                <div style="width:26.66667%;text-align: right;">金额：-${orderData.ReturnMoney}</div>
                                <div style="width:16.66667%;"></div>
                            </div>
                            <div class="order-remark">${
                                footnoteConfig && footnoteConfig.RValue ? footnoteConfig.RValue.replace(/\n/g, '<br/>') : ''
                            }</div>  
                            <div class="order-remark fwb">
                                <div style="width:16.66667%;">开单人：${orderData.Creator}</div>
                                <div style="width:16.66667%;">点货：</div>
                                <div style="width:16.66667%;">验货：</div>
                                <div style="width:16.66667%;"></div>
                            </div>            
                        </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>采购售后单打印</title>

        <style>
        .print-title-view {
            width: 790px;
            position: relative;
            justify-content: space-between;
            align-items: flex-end;
            padding: 0;
        }
        .print-title-view .order-code{
            display: none;
        }
        .order-detail {
            color: #000;
            padding-right: 30px;
        }
        .order-remark {
            width: 762px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            padding-top: 3px;
            color: #000;
        }
        .print-title {
            margin: 0 auto;
            text-align: center;
            font-size: 24px;
            font-weight: bold;
            color: #000;
            min-height: 26px;
            padding-bottom: 5px;
            position: relative;

        }
        .print-zone {
            width: 200mm;
        }
        .print-table-main {
            width: 762px;
            font-size: 14px;
        }
        .print-table-main .div-table-cell {
            overflow: hidden;
            word-break: break-all;
            word-wrap: break-word;
            height: auto;
            line-height: 25px;
            padding-left: 1px;
            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-bottom: 1px solid #000;
            color: #000;
        }
        .print-table-main .tableConten .div-table-cell {
            line-height: 14px;
            display: -webkit-box;
            -webkit-box-orient: horizontal;
            -webkit-box-align: center;
            /*box不兼容是用下面*/
            display: flex;
            align-items: center;
            padding-bottom: 5px;
            padding-top: 5px;                        
        }
        .print-table-main .div-table-row {
            display: flex;
            border-left: 1px solid #000;
        }
        .fdzt {
            font-size: 14px;
        }
        .fwb {
            font-weight: bold;
        }
        .btd {
            border-bottom: 1px dashed #000;
            font-weight: bold;
        }                
        .print-orderDetail {
            width: 762px;
            margin-bottom: 10px;
            font-size: 14px;
            color: #000;
            padding: 0;
            padding-left: 5px;
            margin-right: 20px;
        }
        .print-orderDetail .barfa{
            display:none;
        }
        .print-orderDetail .row {
            margin-left: -10px;
            margin-right: -10px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            margin-bottom: 2px;
        }
        .print-orderDetail .row::after,
        .print-orderDetail .row::before {
            display: table;
            content: '';
            clear: both;
        }
        .print-orderDetail .row .col {
            float: left;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
            line-height: 18px;
            height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .print-orderDetail .col-5 {
            width: 20.83333%;
        }
        .print-orderDetail .col-6 {
            width: 25%;
        }
        .print-orderDetail .col-7 {
            width: 29.16667%;
        }
        .print-orderDetail .col-8 {
            width: 33.33333%
        }                    
        .print-orderDetail .qrcode-canvas,
        .print-orderDetail .qrcode-image {
            width: 40px;
            height: 40px;
            display: inline-block;
            vertical-align: top;
        }

        .print-orderDetail .row .height40 {
            height: 40px !important;
        }

        .print-orderDetail .row .col .label_l {
            width: 70px;
            text-align: left;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .print-orderDetail .row .col .label_r {
            width: 70px;
            text-align: right;
            vertical-align: middle;
            float: left;
            line-height: 18px;
        }
        .w60{width:60px !important;}
        .print-orderDetail .row .col .grid-content {
            display: inline-block;
            min-height: 18px;
            border-radius: unset;
            line-height: 18px;
        } 
        .print-orderDetail .row .col .debts{
            padding-top: 3px;
        }
        .print-orderDetail .row .col .grid-content::after,
        .print-orderDetail .row .col .grid-content::before {
            display: table;
            content: '';
            clear: both;
        } 
        .print-orderDetail .rkCol{
            height: auto !important;
            width: 65%;
            padding-right: 0px !important;
            overflow: unset !important;
            white-space: unset !important;
            text-overflow: unset !important;
        }
        .print-orderDetail .rkCol .grid-content{
            overflow: hidden !important;
            word-break: break-all !important;
            word-wrap: break-word !important;
            white-space: break-spaces !important;
            white-space: pre-wrap !important;
            width: 85% !important;
        }
        table,
        td,
        th {
            border-width: 1px;
            border-style: solid;
            border-collapse: collapse;
            color: #000;
            padding-bottom: 3px;
            padding-top: 3px;
            padding-left: 2px;
        }                                   
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
    return template;
}
/**
 * 生成崇峰采购售后打印页面
 * orderData：订单数据
 */
 function buildCFPurReturnPrintHtml(orderData, footnoteConfig) {
     let tableConten = '';
     let _count = 0;
     let _sum = 0;
    if (orderData.DetailList && orderData.DetailList.length > 0) {
        orderData.DetailList.forEach((AP, index) => {
            tableConten += `
            <div class="div-table-row">
                <div class="div-table-cell" style="width: 6%">${index + 1}</div>
                <div class="div-table-cell" style="width: 20%">${AP.APCode}</div>
                <div class="div-table-cell" style="width: 20%">${AP.GoodName}</div>
                <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
                <div class="div-table-cell" style="width: 7%">${AP.ReturnCount}</div>
                <div class="div-table-cell" style="width: 7%">${AP.Unit}</div>
                <div class="div-table-cell" style="width: 10%">${AP.ReturnPrice}</div>
                <div class="div-table-cell" style="width: 10%">${(AP.ReturnPrice * AP.ReturnCount).toFixed(2)}</div>
            </div>
            `;
            _count += AP.ReturnCount;
            _sum += AP.ReturnPrice;
        });
    }
    let printContent = `
                    <div>
                        <div class="print-title">广州崇峰退货清单</div>
                        <div class="print-content">
                            <div>退货单号：${orderData.ReturnCode}</div>
                            <div>
                                退货日期：${orderData.ReturnTime}
                            </div>
                        </div>
                        <div class="print-table-main">
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 供应商名称</div>
                                <div class="div-table-cell" style="width: 80%">${orderData.EntpCusName}</div>
                            </div>
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 联系电话</div>
                                <div class="div-table-cell" style="width: 80%"></div>
                            </div>                        
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%">序号</div>
                                <div class="div-table-cell" style="width: 20%;">汽配编码</div>
                                <div class="div-table-cell" style="width: 20%;">配件名称</div>
                                <div class="div-table-cell" style="width: 20%;">车型</div>
                                <div class="div-table-cell" style="width: 7%">数量</div>
                                <div class="div-table-cell" style="width: 7%">单位</div>
                                <div class="div-table-cell" style="width: 10%">退单价</div>
                                <div class="div-table-cell" style="width: 10%">退款金额</div>
                            </div>
                                ${tableConten}
                            <div class="div-table-row">
                                <div class="div-table-cell" style="width: 6%"></div>
                                <div class="div-table-cell" style="width: 20%;"></div>
                                <div class="div-table-cell" style="width: 20%;"></div>
                                <div class="div-table-cell" style="width: 20%;">总数量</div>
                                <div class="div-table-cell" style="width: 7%">${ _count }</div>
                                <div class="div-table-cell" style="width: 7%">总价</div>
                                <div class="div-table-cell" style="width: 10%">${ _sum.toFixed(2) }</div>
                                <div class="div-table-cell" style="width: 10%">${ orderData.ReturnMoney }</div>
                            </div>                                
                        </div>
                        <div class="row">
                            <div style="display: inline-block;">退款方式：${ orderData.PayTypeName }</div>
                            <div style="display: inline-block;float: right;">开单人：${ orderData.Creator }</div>
                        </div>
                        <div class="row">退货原因：${ orderData.Reasons }</div>                                         
                    </div>
                    `;
    let template = `
    <!DOCTYPE html>
<html>
    <head>
        <meta charset="utf-8" />
        <title>采购售后单打印</title>

        <style>
        .order-detail {
            color: #000;
            }
            .order-remark {
                width: 762px;
            display: -webkit-flex;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-left: 10px;
            margin-right: 10px;
            padding: 0px 0px 15px 0px;
            color: #000;
            }
            .print-title {
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            color: #000;
            }
            .print-content {width: 762px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #000;
            margin: 12px 0;
            }
            .dialog-footer {
            text-align: right;
            }
            .print-table-main {
            width: 762px;
            margin-bottom: 16px;
            font-size:12px;
            
            }
            .div-table-cell {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                height: auto;
                line-height: 30px;
                padding-left: 10px;
                border-top: 1px solid #000;
                border-right: 1px solid #000;
                border-bottom: 1px solid #000;
                color: #000;
            }
            .row {
                width: 762px;
            color: #000;
            margin-bottom: 16px;
            }
            .div-table-row {
                display: flex;
                border-left: 1px solid #000;
                margin: 0;
                font-size: 14px;
            }                            
        </style>
    </head>
    <body>
        ${printContent}
    </body>
</html>
    `;
     return template;
}
/**
 * 生成公共采购售后打印页面
 * orderData：订单数据
 */
 function buildPurReturnPrintHtml(orderData, footnoteConfig) {
    let tableConten = '';
    let _count = 0;
    let _sum = 0;
   if (orderData.DetailList && orderData.DetailList.length > 0) {
       orderData.DetailList.forEach((AP, index) => {
           tableConten += `
           <div class="div-table-row">
               <div class="div-table-cell" style="width: 6%">${index + 1}</div>
               <div class="div-table-cell" style="width: 20%">${AP.APCode}</div>
               <div class="div-table-cell" style="width: 20%">${AP.GoodName}</div>
               <div class="div-table-cell" style="width: 20%">适用:${AP.AutoSerise}</div>
               <div class="div-table-cell" style="width: 7%">${AP.ReturnCount}</div>
               <div class="div-table-cell" style="width: 7%">${AP.Unit}</div>
               <div class="div-table-cell" style="width: 10%">${AP.PurchasePrice}</div>
               <div class="div-table-cell" style="width: 10%">${(AP.ReturnPrice * AP.ReturnCount).toFixed(2)}</div>
           </div>
           `;
           _count += AP.ReturnCount;
           _sum += AP.ReturnPrice;
       });
   }
   let printContent = `
                   <div>
                       <div class="print-title">采购退货单</div>
                       <div class="print-content">
                           <div>退货单号：${orderData.ReturnCode}</div>
                           <div>
                               退货日期：${orderData.ReturnTime}
                           </div>
                       </div>
                       <div class="print-table-main">
                           <div class="div-table-row">
                               <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 供应商名称</div>
                               <div class="div-table-cell" style="width: 80%">${orderData.EntpCusName}</div>
                           </div>
                           <div class="div-table-row">
                               <div class="div-table-cell" style="width: 20%;padding-left: 0px;">&nbsp;&nbsp;&nbsp; 联系电话</div>
                               <div class="div-table-cell" style="width: 80%"></div>
                           </div>                        
                           <div class="div-table-row">
                               <div class="div-table-cell" style="width: 6%">序号</div>
                               <div class="div-table-cell" style="width: 20%;">汽配编码</div>
                               <div class="div-table-cell" style="width: 20%;">配件名称</div>
                               <div class="div-table-cell" style="width: 20%;">车型</div>
                               <div class="div-table-cell" style="width: 7%">数量</div>
                               <div class="div-table-cell" style="width: 7%">单位</div>
                               <div class="div-table-cell" style="width: 10%">采购价</div>
                               <div class="div-table-cell" style="width: 10%">退款金额</div>
                           </div>
                               ${tableConten}
                           <div class="div-table-row">
                               <div class="div-table-cell" style="width: 6%"></div>
                               <div class="div-table-cell" style="width: 20%;"></div>
                               <div class="div-table-cell" style="width: 20%;"></div>
                               <div class="div-table-cell" style="width: 20%;">总数量</div>
                               <div class="div-table-cell" style="width: 7%">${ _count }</div>
                               <div class="div-table-cell" style="width: 7%">总价</div>
                               <div class="div-table-cell" style="width: 10%">${ _sum.toFixed(2) }</div>
                               <div class="div-table-cell" style="width: 10%">${ orderData.ReturnMoney }</div>
                           </div>                                
                       </div>
                       <div class="row">
                           <div style="display: inline-block;">退款方式：${ orderData.PayTypeName }</div>
                           <div style="display: inline-block;float: right;">开单人：${ orderData.Creator }</div>
                       </div>
                       <div class="row">退货原因：${ orderData.Reasons }</div>                                         
                   </div>
                   `;
   let template = `
   <!DOCTYPE html>
<html>
   <head>
       <meta charset="utf-8" />
       <title>采购售后单打印</title>

       <style>
       .order-detail {
           color: #000;
           }
           .order-remark {
               width: 762px;
           display: -webkit-flex;
           display: flex;
           flex-direction: row;
           justify-content: space-between;
           margin-left: 10px;
           margin-right: 10px;
           padding: 0px 0px 15px 0px;
           color: #000;
           }
           .print-title {
           text-align: center;
           font-size: 20px;
           font-weight: bold;
           color: #000;
           }
           .print-content {width: 762px;
           display: flex;
           justify-content: space-between;
           align-items: center;
           color: #000;
           margin: 12px 0;
           }
           .dialog-footer {
           text-align: right;
           }
           .print-table-main {
           width: 762px;
           margin-bottom: 16px;
           font-size:12px;
           
           }
           .div-table-cell {
               overflow: hidden;
               text-overflow: ellipsis;
               white-space: nowrap;
               height: auto;
               line-height: 30px;
               padding-left: 10px;
               border-top: 1px solid #000;
               border-right: 1px solid #000;
               border-bottom: 1px solid #000;
               color: #000;
           }
           .row {
               width: 762px;
           color: #000;
           margin-bottom: 16px;
           }
           .div-table-row {
               display: flex;
               border-left: 1px solid #000;
               margin: 0;
               font-size: 14px;
           }                            
       </style>
   </head>
   <body>
       ${printContent}
   </body>
</html>
   `;
    return template;
}
export default {
    buildHKSalesPrintHtml,
    buildCFSalesPrintHtml,
    buildHYSalesPrintHtml,
    buildJSSalesPrintHtml,
    buildSalesPrintHtml,
    buildCusRecePrintHtml,
    buildSupPayPrintHtml,
    buildHKPurchasePrintHtml,
    buildCFPurchasePrintHtml,
    buildPurchasePrintHtml,
    buildHKSaleReturnPrintHtml,
    buildCFSaleReturnPrintHtml,
    buildSaleReturnPrintHtml,
    buildHKPurReturnPrintHtml,
    buildCFPurReturnPrintHtml,
    buildPurReturnPrintHtml
};
